module.exports = __webpack_public_path__ + "static/media/benchmark.21c01c89.jpg";